<template>
  <div class="pet-header mb-3">
    <b-row no-gutters align-v="center">
      <b-col cols="auto">
        <base-pet-icon :img="pet.image ? pet.image.original : null" :size="3.5" />
      </b-col>
      <b-col>
        <h2 class="ml-3 mb-0">
          <strong>{{ $t('components.petHeader.for', [pet.name]) }} </strong>
        </h2>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BasePetIcon from '@/components/BasePetIcon';
export default {
  components: {
    BasePetIcon,
  },
  props: {
    pet: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
